import useSWR, { Fetcher } from "swr";

import { getSWRKey, SwrStore } from "~utils";

import { useFirebaseAuth } from "./use-firebase-auth";
import {
  FirestorePersistenceUser,
  UserNotFoundError,
  useUserFirestorePersistence,
} from "./use-user-firestore-persistence";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useFirestoreUserSWR() {
  const { userId } = useFirebaseAuth();
  const fetchUser = useUserFetcher();

  return useSWR(getSWRKey(SwrStore.FirestoreUser, userId), fetchUser, {
    suspense: true,
  });
}

function useUserFetcher(): Fetcher<FirestorePersistenceUser, Key> {
  const { getUser: getFirestoreUser, upsertUser } =
    useUserFirestorePersistence();

  // eslint-disable-next-line max-statements
  return async ([, userId]: Key) => {
    try {
      const firestoreUser = await getFirestoreUser(userId);
      if (firestoreUser.joinedAt) return firestoreUser;

      const migrated = { ...firestoreUser, joinedAt: new Date() };
      await upsertUser(migrated);
      return migrated;
    } catch (error) {
      if (error instanceof UserNotFoundError) {
        const newUser: FirestorePersistenceUser = {
          id: userId,
          joinedAt: new Date(),
        };
        await upsertUser(newUser);
        return newUser;
      }
      throw error;
    }
  };
}

type Key = readonly [SwrStore, string];
